import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysPlanRoadmapRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const careerPlan = await this.reimaginedData.fetchCareerPlan();
    return { careerPlan };
  }
}
